import { Component, OnInit, Input, HostListener, ViewChild, SimpleChanges } from '@angular/core';
import { MatStepper } from '@angular/material';
import * as moment from 'moment';

@Component({
  selector: 'app-estado-step',
  templateUrl: './estado-step.component.html',
  styleUrls: ['./estado-step.component.scss']
})
export class EstadoStepComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;

  @Input () controls: any [] = [];
  @Input () isLinear: boolean = true;

  public innerWidth: any;

  constructor() {
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;

    if (innerWidth <= 768) {
      this.isLinear = false;
    } else {
      this.isLinear = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  get_datetime_format (datetime: any, format: string) {
    return moment (datetime).format (format);
  }


}
